module.exports = __webpack_public_path__ + "static/media/KI221Renew.a345db5a.jpg";